import { INDUSTRIES } from "@/data/content";

export default function Industries() {
  return (
    <section
      data-testid="industries-section"
      className="py-16 md:py-24 border-b hairline bg-[color:var(--bg-soft)]/60"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-y-8 items-center">
          <div className="col-span-12 md:col-span-4">
            <div className="section-label mb-4">
              <span className="dot" /> Industries
            </div>
            <h2 className="font-display text-3xl md:text-4xl font-medium tracking-tight leading-tight">
              Built for{" "}
              <span className="font-serif-accent italic font-normal">
                operators
              </span>{" "}
              who care about revenue.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-8 md:pl-10">
            <div className="flex flex-wrap gap-2">
              {INDUSTRIES.map((i) => (
                <span
                  key={i}
                  data-testid={`industry-chip-${i}`}
                  className="px-4 py-2 rounded-full border hairline bg-white text-sm hover:bg-[color:var(--ink)] hover:text-[color:var(--bg)] transition-colors cursor-default"
                >
                  {i}
                </span>
              ))}
            </div>
            <p className="mt-6 text-sm text-[color:var(--ink-2)] max-w-2xl">
              From clinics and D2C brands to B2B firms across Mumbai — we've
              helped businesses like yours build websites, rank on Google, and
              automate operations.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
